
import { Component, Vue, Watch } from 'vue-property-decorator';

// Enums
import ModalEnum from '@/ship/Enums/ModalEnum';

// Components
import VPrescriptionDrawingUpload from '@/components/Prescription/VPrescriptionDrawingUpload.vue';

@Component({
    components: {
        VPrescriptionDrawingUpload,
    },
})
export default class PrescriptionDrawingPage extends Vue {
    @Watch('$isDesktop')
    public desktopBreakpointWatchHanler() {
        (this.$isDesktop ? this.hidePlugModal : this.showPlugModal)();
    }

    public showPlugModal() {
        this.$modal.show(ModalEnum.Alert, {
            title: this.$t('unavailableOnMobileDevicePlug.title'),
            description: this.$t('unavailableOnMobileDevicePlug.description'),
            actionLabel: this.$t('goBack'),
            actionCallback: () => {
                this.hidePlugModal();
                this.$router.back();
            },
        });
    }

    public hidePlugModal = () => this.$modal.hide(ModalEnum.Alert);

    public mounted() {
        this.desktopBreakpointWatchHanler();
    }

    public beforeDestroy() {
        this.hidePlugModal();
    }
}
